var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confirmation-sent-page"},[_c('confirmation-sent-pane',{staticClass:"confirmation-sent-page__content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }